export default {
  ROLE_ADMIN: 'Super Admin',
  ROLE_COMPANY_ADMIN: 'Company Admin',
  ROLE_BOUNTY_ADMIN: 'Bounty Admin',
  ROLE_COMPANY_USER: 'Company User',
  ROLE_ADVERTISER: 'Advertising Agency',
};
